import { PropsWithChildren } from 'react';

import Text from 'components/Text';
import { cn } from 'utils';

import { XOutlineIcon } from 'assets/svgs';

interface Props extends PropsWithChildren {
  onClickClose?: () => void;
  title?: string;
  className?: string;
}

const ModalInner = ({ children, onClickClose, title, className }: Props) => {
  return (
    <div className={cn('h-fit w-full overflow-hidden rounded-2xl bg-white shadow-primary md:w-[600px]', className)}>
      {title && (
        <div className="flex flex-row items-center justify-between p-4">
          <Text size="body1" weight="medium">
            {title}
          </Text>
          <button type="button" className="flex h-8 w-8 items-center justify-center" onClick={onClickClose}>
            <XOutlineIcon className="h-4 w-4" />
          </button>
        </div>
      )}
      {children}
    </div>
  );
};

export default ModalInner;
